import { useEffect, useState } from "react";
import { FirestoreService } from "../../../../api/firebase/firestoreService";
import { FirestoreDocumentReference } from "../../../../api/firebase/references";
import type { CallingRuleDoc } from "./callingRuleUtils";

/** Fetches the calling rule Firestore doc once on mount.
 * Returns `data: null` when the doc does not exist yet — the page can render an empty editor and create it on save. */
export function useCallingRuleConfig() {
  const [data, setData] = useState<CallingRuleDoc | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    let cancelled = false;

    const fetchConfig = async () => {
      setLoading(true);
      setError(null);
      try {
        const path =
          FirestoreDocumentReference.pharmacyOrderUpdatesCallingRule();
        const result = await FirestoreService.getDocument<CallingRuleDoc>(path);
        if (!cancelled) {
          setData(result);
        }
      } catch (err) {
        const message = err instanceof Error ? err.message : String(err);
        if (message.includes("does not exist")) {
          if (!cancelled) {
            setData(null);
          }
        } else {
          const errorInstance =
            err instanceof Error ? err : new Error(String(err));
          if (!cancelled) setError(errorInstance);
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    fetchConfig();
    return () => {
      cancelled = true;
    };
  }, []);

  return { data, loading, error };
}
